import { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import MyTextField from "../../components/inputs/MyTextField";
import MyButton from "../../components/MyButton";
import { useUser } from "../../hooks/useUser";
import { SiteContext } from "../../context/SiteProvider";
import { AuthContext } from "../../context/AuthProvider";

const MyPage03 = () => {
  const { changePasswordMutation } = useUser();
  const { setLoadingScreen } = useContext(SiteContext);
  const { profile, isAuthenticated } = useContext(AuthContext);

  const initValues = {
    password: "",
    rePassword: "",
    newPassword: "",
  };

  const validationSchema = yup.object({
    password: yup.string().required("필수 입력 항목입니다."),
    newPassword: yup
      .string()
      .min(6, "비밀번호 생성 규칙에 맞게 다시 입력해주세요.")
      .max(16, "비밀번호 생성 규칙에 맞게 다시 입력해주세요.")
      .matches(
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).+$/,
        "비밀번호 생성 규칙에 맞게 다시 입력해주세요."
      )
      .required("필수 입력 항목입니다."),
    rePassword: yup
      .string()
      .required("필수 입력 항목입니다.")
      .oneOf([yup.ref("newPassword")], "비밀번호가 일치하지 않습니다."),
  });

  const methods = useForm({
    defaultValues: initValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      oldPassword: data.password,
      newPassword: data.newPassword,
    };

    setLoadingScreen(true);
    changePasswordMutation.mutate(
      { userId: profile.userId, payload },
      {
        onSuccess: (res) => {
          if (res?.accessToken) {
            methods.reset();
            alert("비밀번호 변경 성공.");
            localStorage.setItem("accessToken", res.accessToken);
          } else {
            alert("비밀번호가 정확하지 않습니다.");
            methods.setError("password", {
              message: "비밀번호가 정확하지 않습니다.",
            });
            return;
          }
        },
        onError: (err) => {
          if (err.data.code === "INVALID_CREDENTIAL") {
            alert("비밀번호가 정확하지 않습니다.");
            methods.setError("password", {
              message: "비밀번호가 정확하지 않습니다.",
            });
            return;
          } else {
            alert("오류가 발생했습니다.");
          }
        },
        onSettled: () => {
          setLoadingScreen(false);
        },
      }
    );
  };

  return isAuthenticated ? (
    <div className="flex justify-center">
      <div className="w-full max-w-[600px] pt-10">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="flex flex-wrap gap-y-5"
          >
            <div className="w-full flex flex-col">
              <label htmlFor="password" className="w-[100px] font-semibold">
                비밀번호 <span className="text-error">*</span>
              </label>
              <div className="w-full">
                <MyTextField
                  id="password"
                  type="password"
                  name="password"
                  placeholder="현재 비밀번호를 입력하세요."
                />
              </div>
              <div className="w-full mt-5">
                <MyTextField
                  id="newPassword"
                  type="password"
                  name="newPassword"
                  placeholder="새로운 비밀번호를 입력하세요."
                />
              </div>
              <div className="w-full mt-5">
                <MyTextField
                  id="rePassword"
                  type="password"
                  name="rePassword"
                  placeholder="비밀번호를 한번 더 입력해주세요."
                />
              </div>
            </div>

            <MyButton
              variant="contained"
              color="primary"
              className="w-full font-semibold h-[56px]"
              type="submit"
              size="small"
            >
              비밀번호 변경하기
            </MyButton>
          </form>
        </FormProvider>
      </div>
    </div>
  ) : null;
};

export default MyPage03;
